var BikeScript = (function($){

    var Init = function(){

        bike_sel = false;
        lang_sel = false;

        $(document).on("click touchstart",".bike-form-button",function(){
          bike_sel = $(this).data('sel-val');
          lang_sel = $(this).data('sel-lang');
        });

        // Prevent mark more than 3 items
        $(document).on("change",".js-bl-cb",function(){
          if($(this).is(':checked')){
            if($('.js-bl-cb:checked').length>3){
              $(this).attr('checked', false);
            }else{
              if($('.js-bl-cb:checked').length>1){
                $('.js-bl-cb:checked').each(function(){
                  $(this).prev('.bl-cb-label').hide();
                  $(this).parents('.bl-cb-container').next('.js-bike-compare').css('display','inline-block');
                });
              }
            }
          }else{
            $(this).prev('.bl-cb-label').show();
            $(this).parents('.bl-cb-container').next('.js-bike-compare').css('display','none');
            if($('.js-bl-cb:checked').length == 1){
              $('.js-bl-cb:checked').each(function(){
                $(this).prev('.bl-cb-label').show();
                $(this).parents('.bl-cb-container').next('.js-bike-compare').css('display','none');
              });
            }
          }
        });

        // compare click
        $(document).on("click",".js-bike-compare",function(){
          var redirect = window.location.href+"compara";
          $('.js-bl-cb:checked').each(function(){
            redirect += "/"+$(this).data('bike');
          });
          // console.log(redirect);
          window.location.href = redirect;
        });

        // $('.bike-form-button').hide();
        $(window).on('load',function() {
          $('.bike-form-button').show();
        });

        $(document).on('opened', '.remodal', function () {
          var lang_field = $(this).find("select[name='fld_8006989']");
          var sel_field = $(this).find("select[name='fld_430755']");
          lang_field.changeVal(lang_sel);
          sel_field.changeVal( bike_sel );
          $('select[name="fld_430755"] option:not(:selected)').hide();
        });

        $.fn.changeVal = function (v) {
          return this.val(v).trigger("change");
        };

        $( ".bt-res-menu" ).on( "click", "li", function() {
          var pos = $(this).index()+2;
          $("tr").find('td:not(:eq(0))').hide();
          $('td:nth-child('+pos+')').css('display','table-cell');
          $("tr").find('th:not(:eq(0))').hide();
          var current_menu_pos = $(this).parent().data('menu-pos');
          var current_tab = $(this).data('pos');
          $('.bt-res-menu').each(function(){
            if( $(this).data("menu-pos") != current_menu_pos ){
              $(this).find('.activebike').removeClass('activebike');
              $(this).find('li[data-pos="'+current_tab+'"]').addClass('activebike');
              $('.js-bike').each(function(){
                if($(this).data('pos') == current_tab && $(window).width()<=555 ){
                  $(this).show();
                }else{
                  $(this).hide();
                }
              });

            }
          });
          $(this).parent().find('.activebike').removeClass('activebike');
          $(this).addClass('activebike');

        });

        // Initialize the media query
        var mediaQuery = window.matchMedia('(min-width: 555px)');

        // Add a listen event
        mediaQuery.addListener(doSomething);

        // Function to do something with the media query
        function doSomething(mediaQuery) {
          $(".activebike").each(function(){
            $(this).click();
          });
        }

        // On load
        doSomething(mediaQuery);
    };

    // "public" methods
    return {
        Init : Init
    };

})(jQuery);
